var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewForwardOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7218 16.8098C28.0473 16.5308 28.2101 16.3913 28.2697 16.2253C28.322 16.0796 28.322 15.9202 28.2697 15.7745C28.2101 15.6085 28.0473 15.469 27.7218 15.19L16.4275 5.5092C15.8672 5.02893 15.5871 4.7888 15.3499 4.78292C15.1437 4.77781 14.9468 4.86837 14.8166 5.02821C14.6667 5.21212 14.6667 5.5811 14.6667 6.31907V12.0461C11.8204 12.544 9.21546 13.9862 7.27961 16.1517C5.1691 18.5126 4.00165 21.5678 4 24.7345V25.5505C5.39912 23.8651 7.14601 22.5019 9.12101 21.5545C10.8623 20.7191 12.7446 20.2243 14.6667 20.0939V25.6807C14.6667 26.4187 14.6667 26.7877 14.8166 26.9716C14.9468 27.1314 15.1437 27.222 15.3499 27.2169C15.5871 27.211 15.8672 26.9709 16.4275 26.4906L27.7218 16.8098Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewForwardOutline);
export default __webpack_public_path__ + "static/media/preview_forward_outline.e878f14b026eb23b00e95e4b353d8af1.svg";
export { ForwardRef as ReactComponent };